export enum ResearchCellBlock {
  Root = 'ResearchCell',
}
